export const VERSION = '1.0.24.115';
export const API_VERSION = '1.0.24.209';

export const ENDPOINTS = {
	// local dev
	//API: 'http://localhost:5261/api',

	// dev azure
	//API: 'https://sierra-proposal-api-dev.azurewebsites.net/api',

	// dev azure
	API: 'https://sierra-proposal-api-prod.azurewebsites.net/api',
};

export const API_METHOD = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT'
};

export const AUTH_HEADER = {
    AUTH: {
        'Authorization': null,
        'Content-Type': 'application/json; charset=utf-8'
    },
    NO_AUTH: {
        'Content-Type': 'application/json; charset=utf-8'
    }
};

export const BUTTON_ACTIONS = {
    INSERT: 'Insert',
    UPDATE: 'Update',
    EDIT: 'Edit',
    DELETE: 'Delete'
};

export const QCE_FREQUENCY_TYPES = {
    ANNUAL: {value: 1, label: 'Annual'},
    SEMI_ANNUAL: {value: 2, label: 'Semi-annual'},
    QUARTERLY: {value: 4, label: 'Quarterly'},
};

export const BADGE_TYPES = {
    SUCCESS: {color: 'soft-success', icon: 'check', iconColor: 'green'},
    DANGER: {color: 'soft-danger', icon: 'ban', iconColor: 'red'},
    SECONDARY: {color: 'soft-secondary', icon: '', iconColor: ''},
    INFO: {color: 'soft-info', icon: '', iconColor: ''},
    PRIMARY: {color: 'soft-primary', icon: '', iconColor: ''},
};

export const PROPOSAL_STATUSES = {
    DRAFT: {value: 0, label: 'Draft'},
    SENT: {value: 1, label: 'Sent'},
    VIEWED: {value: 2, label: 'Viewed'},
    SUBMITTED: {value: 3, label: 'Submitted'},
    ACCEPTED: {value: 4, label: 'Accepted'},
    CANCELLED: {value: 5, label: 'Inactive'},
    ARCHIVED: {value: 6, label: 'Archived'},
    INACTIVE: {value: 7, label: 'Inactive'},
    MODIFIED: {value: 8, label: 'Modified'},
};

export const PROPOSAL_VIEW = {
    ALL: 'ALL',
    CURRENT: 'CURRENT',
    EXPIRING: 'EXPIRING',
}
